import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetExhibitorsQuery } from "../../../hooks/scientific/useGetExhibitorsQuery";
import { routes } from "../../../routes";
import { ExhibitorType } from "../../../types/ScientificModule";
import { Key_exhibitors } from "../../../utils/constants";
import { updateExhibitor } from "../../../services/scientific/exhibitor";
import { setExhibitorsData } from "../../../redux/slices/scientific/exhibitor";

const columnNamesMap: { [key: string]: string } = {
  //idUser: "Usuário",
  fullname: "Nome completo",
  address: "Endereço",
//   country: "País",
//   status: "Status",
};

export const Exhibitors = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetExhibitorsQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<ExhibitorType | null>(null);

  const mutationUpdate = useMutation(updateExhibitor, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_exhibitors);
      toast.success("Expositor Apagado");
    },
    onError: () => {
      toast.error("Erro ao atualizar o Expositor.");
    },
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleClickCreate = () => {
    navigate(routes.createExhibitor);
  };

  const handleEdit = (exhibitor: ExhibitorType) => {
    dispatch(setExhibitorsData(exhibitor));
    navigate(routes.updateExhibitor);
  };

  const handleDelete = (exhibitor: ExhibitorType) => {
    exhibitor.status = false;
    mutationUpdate.mutateAsync(exhibitor);
  };

  const openDeleteDialog = (exhibitor: ExhibitorType) => {
    setDeleteItem(exhibitor);
  };

  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem);
    }
  };

  const options = data?.items.map((exhibitor: ExhibitorType) => [
    {
      label: "Editar",
      onClick: () => handleEdit(exhibitor),
      icon: <Pencil1Icon />,
    },
    {
      label: "Excluir",
      onClick: () => openDeleteDialog(exhibitor),
      icon: <TrashIcon />,
    },
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() => (
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        )}
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
};
